import { render } from "./CreatePresentation.vue?vue&type=template&id=7934e57c"
import script from "./CreatePresentation.vue?vue&type=script&lang=js"
export * from "./CreatePresentation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__